import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'
import { useTranslation } from 'translations'

const ENGAGE_TOOLS_STATS_TAB_NODE_ID = '4XINHRLFu9'

interface EngageToolsStatsPageProps {
    accountSlug: string
}

const EngageToolsStatsPage = ({ accountSlug }: EngageToolsStatsPageProps) => {
    const { t } = useTranslation()
    return (
        <RedirectPage
            oldPageTitle={t('engageTools.stats.oldPageTitle')}
            newPageTitle={t('engageTools.stats.newPageTitle')}
            action={t('engageTools.stats.action')}
            image={barcodesReportImage}
            link={`/account/${accountSlug}/reports/marketing/#${ENGAGE_TOOLS_STATS_TAB_NODE_ID}`}
        />
    )
}

export default EngageToolsStatsPage
